import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconStar: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 17.4697L17.8514 21L16.3035 14.3407L21.4688 9.86292L14.6594 9.27816L12 3L9.34017 9.27816L2.53125 9.86292L7.6965 14.3407L6.14817 21L12 17.4697Z"
        fill={fill || '#26262'}
      />
    </Icon>
  );
};

export default IconStar;
